import * as S from './PageLine.styled'

export const PageLine = ({ itemRef, ...props }) => (
  <S.Line ref={itemRef} {...props} />
)

export default PageLine
